import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-md-3" }
const _hoisted_5 = { class: "card-img" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "text-center"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" dagar till. ")
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Ditt lånelöfte är giltigt i ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" dagar till. ")
const _hoisted_13 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  style: {"height":"20px"},
  class: "row"
}, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "col-md-8"
}
const _hoisted_16 = { class: "row mb-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Lånebelopp", -1)
const _hoisted_18 = { class: "col-6" }
const _hoisted_19 = {
  key: 0,
  class: "row mb-1"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Varav privatlån", -1)
const _hoisted_21 = { class: "col-6" }
const _hoisted_22 = { class: "row mb-1" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Månadskostnad", -1)
const _hoisted_24 = { class: "col-6" }
const _hoisted_25 = { class: "row mb-1" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Nominell ränta", -1)
const _hoisted_27 = { class: "col-6" }
const _hoisted_28 = { class: "row mb-1" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Effektiv ränta", -1)
const _hoisted_30 = { class: "col-6" }
const _hoisted_31 = { class: "row mb-1" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Amortering", -1)
const _hoisted_33 = { class: "col-6" }
const _hoisted_34 = {
  key: 0,
  class: "card-content"
}
const _hoisted_35 = { class: "row mb-1" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Ränta", -1)
const _hoisted_37 = { class: "col-6" }
const _hoisted_38 = {
  key: 0,
  class: "row mb-1"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Månadskostnad vid kalkylränta", -1)
const _hoisted_40 = { class: "col-6" }
const _hoisted_41 = { class: "row mb-1" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Bindningstid", -1)
const _hoisted_43 = { class: "col-6" }
const _hoisted_44 = { class: "row mb-1" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Uppläggningsavgift", -1)
const _hoisted_46 = { class: "col-6" }
const _hoisted_47 = { class: "row mb-1" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Aviavgift", -1)
const _hoisted_49 = { class: "col-6" }
const _hoisted_50 = {
  key: 1,
  class: "col-md-1"
}
const _hoisted_51 = {
  key: 0,
  class: "btn btn-sm btn-outline"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-chevron-down",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
  })
], -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = {
  key: 1,
  class: "btn btn-sm btn-outline"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-chevron-up",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
  })
], -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = {
  key: 2,
  class: "col-md-7 offset-md-1"
}
const _hoisted_58 = { class: "col-lg-9 offset-lg-3" }
const _hoisted_59 = { class: "card-content" }
const _hoisted_60 = {
  key: 0,
  class: "pt-3 mt-1"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-9" })
], -1)
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = {
  key: 1,
  class: "pt-3 mt-1"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-9" })
], -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = {
  key: 2,
  class: "border-top border-light pt-3 mt-3"
}
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "col-lg-4 offset-lg-0 col-md-6 offset-md-3 d-grid my-3" }
const _hoisted_69 = {
  key: 3,
  class: "border-top border-light pt-3 mt-3"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("h3", { class: "offer-title" }, " Räntesatser vid olika bindningstider ", -1)
const _hoisted_71 = { class: "table-responsive" }
const _hoisted_72 = { class: "table table-borderless table-striped" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Bindningsperiod"),
    /*#__PURE__*/_createElementVNode("th", null, "Ränta innan rabatt"),
    /*#__PURE__*/_createElementVNode("th", null, "Rabatt"),
    /*#__PURE__*/_createElementVNode("th", null, "Ränta efter rabatt")
  ])
], -1)
const _hoisted_74 = {
  key: 4,
  class: "border-top border-light pt-3 mt-3"
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("h3", { class: "offer-title" }, "Om lånet", -1)
const _hoisted_76 = { class: "offer-description" }
const _hoisted_77 = {
  key: 5,
  class: "border-top border-light pt-3 mt-3"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("h3", { class: "offer-title" }, "Om banken", -1)
const _hoisted_79 = { class: "offer-description" }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" Läs mer ")
const _hoisted_82 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-caret-down-fill",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" })
], -1)
const _hoisted_83 = [
  _hoisted_81,
  _hoisted_82
]
const _hoisted_84 = {
  key: 6,
  class: "border-top border-light pt-3 mt-3"
}
const _hoisted_85 = /*#__PURE__*/_createElementVNode("h3", { class: "offer-title" }, "Representativt Exempel", -1)
const _hoisted_86 = { class: "offer-description" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("p", null, " Observera att vi enligt lag behöver visa detta exempel. Det är inte de lånevillkor som du har fått. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["card card-feat", { 'content-card-npb': _ctx.expanded }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                class: "img-fluid",
                src: _ctx.offer.bank.offerImage
              }, null, 8, _hoisted_6),
              (_ctx.showRenewal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (!_ctx.isPastDueDate && _ctx.offer.offerDueDateTextType != null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createTextVNode(_toDisplayString(_ctx.getOfferDueDateText) + " Förslaget är giltigt i ", 1),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.daysLeftUntilDueDate), 1),
                          _hoisted_9
                        ]))
                      : (!_ctx.isPastDueDate && _ctx.offer.offerDueDateTextType == null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _hoisted_11,
                            _createElementVNode("strong", null, _toDisplayString(_ctx.daysLeftUntilDueDate), 1),
                            _hoisted_12
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_13, " Ditt lånelöfte har löpt ut. "))
                  ]))
                : _createCommentVNode("", true),
              _hoisted_14
            ])
          ]),
          (!_ctx.isPastDueDate || !_ctx.showRenewal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: "card-content",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expanded = !_ctx.expanded))
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.offer.approvedAmount)) + " kr", 1)
                    ])
                  ]),
                  (_ctx.offer.privateLoanApprovedAmount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.offer.privateLoanApprovedAmount)) + " kr ", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.offer.monthlyInstallment)) + " kr ", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.offer.interestRate != null
                        ? _ctx.formatDecimal(_ctx.offer.interestRate)
                        : "") + " % ", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.offer.interestRate != null
                        ? _ctx.formatDecimal(_ctx.offer.effectiveRate)
                        : "") + " % ", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.offer.amortizationPayment)) + " kr", 1)
                    ])
                  ])
                ]),
                (_ctx.expanded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.offer.interestPayment)) + " kr", 1)
                        ])
                      ]),
                      (_ctx.offer.discountRateMonthlyInstallment)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _hoisted_39,
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.offer.discountRateMonthlyInstallment)) + " kr", 1),
                              _createVNode(_component_tooltip, { title: "Kalkylränta är en räntesats som banker och långivare räknar på vid bolåneansökningar för att säkerställa att bolånekunder kan klara av en högre kostnad om räntorna skulle höjas." })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_41, [
                        _hoisted_42,
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.offer.paybackYearsFixed
                        ? _ctx.offer.paybackYearsFixed.toLocaleString()
                        : _ctx.bindingPeriod(_ctx.offer.interestBindingPeriod)) + " mån ", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.offer.arrangementFee) + " kr", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.offer.administrationFee) + " kr", 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isPastDueDate || !_ctx.showRenewal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createElementVNode("div", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expanded = !_ctx.expanded)),
                  class: "card-btn"
                }, [
                  (!_ctx.expanded)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_51, _hoisted_53))
                    : (_openBlock(), _createElementBlock("button", _hoisted_54, _hoisted_56))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isPastDueDate && _ctx.showRenewal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createRenewalUrl && _ctx.createRenewalUrl(...args))),
                  class: "btn btn-primary"
                }, " Förnya lånelöfte ")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_Transition, { name: "slide" }, {
          default: _withCtx(() => [
            (_ctx.expanded)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "row",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      (_ctx.missingDocumentSkandia(_ctx.offer.status, _ctx.offer.bank.name))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, _hoisted_62))
                        : (_ctx.offerIsSelected(_ctx.offer.id))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_63, _hoisted_65))
                          : (_openBlock(), _createElementBlock("div", _hoisted_66, [
                              _createElementVNode("div", _hoisted_67, [
                                _createElementVNode("div", _hoisted_68, [
                                  _createElementVNode("button", {
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitSelectOffer(_ctx.offer.id))),
                                    class: "btn btn-primary"
                                  }, " Välj " + _toDisplayString(_ctx.bankName), 1)
                                ])
                              ])
                            ])),
                      (_ctx.offer.possibleInterestRates.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                            _hoisted_70,
                            _createElementVNode("div", _hoisted_71, [
                              _createElementVNode("table", _hoisted_72, [
                                _hoisted_73,
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offer.possibleInterestRates, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: item }, [
                                      _createElementVNode("td", null, _toDisplayString(_ctx.translateBindinPeriod(item.bindingPeriod)), 1),
                                      _createElementVNode("td", null, _toDisplayString(item.interestRateBeforeDiscount) + " %", 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.addMinuSign(item.discount)) + " %", 1),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("strong", null, _toDisplayString(item.interestRateAfterDiscount) + " %", 1)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.offer.bank.offerAdditions)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                            _hoisted_75,
                            _createElementVNode("div", _hoisted_76, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.offer.bank.offerAdditions), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.offer.bank.introDescription)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                            _hoisted_78,
                            _createElementVNode("div", _hoisted_79, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.offer.bank.introDescription), 1),
                              _withDirectives(_createElementVNode("p", null, [
                                (_ctx.headerExpandDescription)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_80, _toDisplayString(_ctx.offer.bank.expandedDescription), 1))
                                  : _createCommentVNode("", true),
                                (!_ctx.headerExpandDescription)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      href: "#",
                                      class: "btn btn-xs btn-outline",
                                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.headerExpandDescription = true), ["prevent"]))
                                    }, _hoisted_83))
                                  : _createCommentVNode("", true)
                              ], 512), [
                                [_vShow, 
                        _ctx.offer.bank.expandedDescription != null &&
                        _ctx.offer.bank.expandedDescription != ''
                      ]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.offer.bank.representativeText)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                            _hoisted_85,
                            _createElementVNode("div", _hoisted_86, [
                              _hoisted_87,
                              _createElementVNode("p", null, _toDisplayString(_ctx.offer.bank.representativeText), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ], 2)
  ]))
}